import { BEEntity } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { CopyContent } from '../../../../../../../libs/com/MetaPattern/Product/IDE/Util/CopyContent';
import { ContextMenu, ContextEnumItemGroup, ContextEnumItem } from '../../BaseShape/ContextMenu';

export class ComponentContextMenu extends ContextMenu {
  constructor(cell?: any, evtTarget?: any, data?: any) {
    super();
    const content = new Array<ContextEnumItemGroup>();
    const baseGroup = new ContextEnumItemGroup();
    baseGroup.addItem(new ContextEnumItem('模型校验', 'component:validate', true));
    content.push(baseGroup);
    if (data !== null) {
      const copyContents = data as Array<CopyContent>;
      if (copyContents.length === 1) {
        const editGroup = new ContextEnumItemGroup();
        editGroup.addItem(new ContextEnumItem('粘贴', 'component:paste', true));
        const element = copyContents[0].curElement;
        if (element instanceof BEEntity) {
          editGroup.addItem(new ContextEnumItem('粘贴为DTO', 'component:paste:DTO', true));
        }
        content.push(editGroup);
        this.set('hasEditGroup', false);
      }
    }
    const printGroup = new ContextEnumItemGroup();
    printGroup.addItem(new ContextEnumItem('保存SVG文件', 'component:saveSVG', true));
    content.push(printGroup);

    this.set('content', content);
  }
}
